'use strict';

const logLevel = process.env.LOG_LEVEL || "warn";
const logLevels = Object.freeze({
  info: 1,
  debug: 2,
  warn: 3,
  error: 4
});
const isDev = process.env.NODE_ENV === "development";
const logger = {
  info: (message, correlationId) => {
    if (isDev || logLevels[logLevel] === 1) {
      console.log(correlationId, message);
    }
  },
  debug: (message, correlationId) => {
    if (isDev || logLevels[logLevel] <= 2) {
      console.debug(correlationId, message);
    }
  },
  warn: (message, correlationId) => {
    if (isDev || logLevels[logLevel] <= 3) {
      console.warn(correlationId, message);
    }
    if (typeof window !== "undefined" && window.appInsights) {
      window.appInsights.trackTrace({
        message,
        severityLevel: 2
      });
    }
  },
  error: (message, correlationId) => {
    if (isDev || logLevels[logLevel] <= 4) {
      console.error(correlationId, message);
    }
    if (typeof window !== "undefined" && (window === null || window === void 0 ? void 0 : window.appInsights)) {
      window.appInsights.trackException({
        error: new Error(message.toString()),
        severityLevel: 3
      });
    }
  }
};
const Logger = {
  info(message) {
    let correlationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
    logger.info(message, correlationId);
  },
  debug(message) {
    let correlationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
    logger.debug(message, correlationId);
  },
  warn(message) {
    let correlationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
    logger.warn(message, correlationId);
  },
  error(message) {
    let correlationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
    logger.error(message, correlationId);
  },
  stream: {
    write(message) {
      logger.debug(message, "root");
    }
  }
};
module.exports = Logger;